import { FeatureResponse as Feature } from '@itemis-solutions/platform-client-sdk'

export interface IProject {
  id: number
  name: string
  creationDate?: string
  favorite?: boolean
  resourceId?: string
  description?: string
  features?: Feature[]
  slug?: string
}

export class Project implements IProject {
  id = -1
  name = ''
  creationDate? = ''
  description? = ''
  favorite? = false
  resourceId?: string
  features?: Feature[]
  slug?: string
}

export interface ProjectListItem {
  projectname: string
  updated: Date | undefined
  id: number
  favorite: boolean | undefined
}
